import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceTSplit extends PoolDevice implements PoolDeviceInterface {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.T;
    static Icon = "split";
    static PickerTitle = Locale.gettext("T Split");
}
